import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import "../../Form.css";
import useForm from "react-hook-form";
import vars from "../../../utils/variables";

const ConfirmUser = ({ history }) => {
  const id = history.location.state.id;
  const [error, setError] = useState(false);
  
  const { handleSubmit } = useForm();

  const handleFetch = () => {
    fetch(`${vars.server}/administration/acceptUserFiles/` + id, {
      method: "POST",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.success) {
          history.push("/adminrequests");
        } else {
          setError(result.message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFetch)} className="formForm">
      <h1>Nutzer akzeptieren</h1>
      {error && <p className="errorMessage">Fehler: {error}</p>}
      <p>Um den Nutzer zu akzeptieren, bestätigen Sie bitte mit "Nutzer akzeptieren".</p>
      <br />
      <br />
      <input type="submit" value="Nutzer akzeptieren" className="inputRLSubmit delete" />
    </form>
  );
};

export default withRouter(ConfirmUser);
